import React from 'react';

const LogoutIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className="c-LogoutIcon"
  >
    <path
      d="M9.66667 19H6.55556C5.69645 19 5 18.3036 5 17.4444V6.55556C5 5.69645 5.69645 5 6.55556 5H9.66667"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.1094 15.8891L18.9983 12.0002L15.1094 8.11133"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.9974 12.0002H9.66406"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default LogoutIcon;
